import React, { useContext } from "react"
import { observer } from "mobx-react"
import { Anchor, Text, Title } from "@mantine/core"
import { IconArrowRight } from "@tabler/icons-react"
import { AppWorkspaceContext } from "../../stores/AppWorkspace"
import { LANDING_COPY, LIVE_PLATFORMS, PLATFORMS_INDEX } from "../../../docs/catalog"
import { PLATFORMS_HASH, PLATFORMS_PATH } from "../../helpers/constants"
import { PlatformCard } from "./PlatformCard"

// The homepage's PLATFORMS section (contract v8): one card per platforms[] row
// that has a page, in the contract's order, styled like the framework grid it
// sits next to and never mixed into it. Planned rows live on /platforms only.
//
// While only a few platforms have pages this sits BELOW the frameworks. Once
// the AI builders (v0, Replit, Lovable) are live, move it above them in
// HomePage.tsx: many people who use those tools do not know their framework.
export const PlatformGrid: React.FC = observer(() => {
  const workspace = useContext(AppWorkspaceContext)
  const copy = LANDING_COPY.platforms
  if (LIVE_PLATFORMS.length === 0) return null

  return (
    <section id={PLATFORMS_HASH} className="or-frameworks or-platforms" aria-labelledby="or-platforms-title">
      <Text className="or-eyebrow">{copy.eyebrow}</Text>
      <Title order={2} id="or-platforms-title" className="or-frameworks-title">
        {copy.headline}
      </Title>
      <Text className="or-frameworks-lede">{copy.subline}</Text>

      <ul className="or-framework-cards">
        {LIVE_PLATFORMS.map((platform) => (
          <PlatformCard key={platform.id} platform={platform} />
        ))}
      </ul>

      <Anchor
        className="or-platforms-all"
        href={PLATFORMS_INDEX?.path ?? PLATFORMS_PATH}
        onClick={(event) => {
          event.preventDefault()
          workspace.goPlatforms()
        }}
      >
        See all platforms <IconArrowRight size={14} aria-hidden="true" />
      </Anchor>
    </section>
  )
})
